import { useEffect, useState } from 'react';
import Logger from 'utils/Logger';
import { getScript } from 'utils/getScript';

const GOOGLE_MAPS_SCRIPT =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyB_wv1Djbu3T7E1wYgE2zqJmkw7zxQvJrQ&libraries=places&language=en&callback=initMap';
declare const window: any;
function isMapsLoaded() {
  return window.googleMapsLoaded || false;
}

window.initMap = () => {
  window.googleMapsLoaded = true;
  Logger.log('google maps loaded');
};

let googleMapsPromise: Promise<unknown> | null = null;
const loadGoogleMaps = () => {
  if (!googleMapsPromise) {
    Logger.log('loading google maps');
    googleMapsPromise = getScript(GOOGLE_MAPS_SCRIPT);
  }
  return googleMapsPromise;
};

export default function useGoogleMaps() {
  const [isLoaded, setLoaded] = useState(isMapsLoaded());

  useEffect(() => {
    if (!isLoaded) {
      loadGoogleMaps().then(() => setLoaded(true));
    }
    return () => {};
  }, [isLoaded]);

  return isLoaded;
}
